export const environment = {
  production: false,
  replace: false,
  gtagId: "",
  configUrl: "/assets/config.local.json"
};
